export const getByPath = (obj: unknown, path?: string[]): unknown => {
  if (!path || path.length === 0) return obj;
  return path.reduce((acc: unknown, key) => {
    if (acc && typeof acc === "object" && key in acc)
      return (acc as Record<string, unknown>)[key];
    return undefined;
  }, obj);
};
